import React, {Component} from 'react';
import {AiFillGithub, DiAndroid} from "react-icons/all";
import {Card, CardGroup, Col, Container, Row} from "react-bootstrap";
import Egghead from "../img/2.png";
import Typescript from "../img/1.png";
import Duzce from "../img/1519919219790.png";
import Google from "../img/1519952113058.png";
import {FiChevronsRight} from "react-icons/fi";

class Projeler extends Component {
    render() {
        return (
        <div className="row">
            <div  style={{float:"left",textAlign:"center",alignItems:"center",marginTop:62,fontSize:50,fontFamily: 'Architects Daughter'}} className="col-sm-10">
                <p style={{fontSize:20, borderLeft: "solid",  borderColor: "blue", background: "Azure"}}>
                    Yaptığım projeleri, son yaptığımdan ilk yaptığıma doğru görebilirsiniz. Her birini <a href="https://github.com/celebiali"><span style={{color:"royalblue"}}>Github</span></a>'ımda saklıyor olacağım.
                </p>
            </div>
            <div  className="col-sm-2"><a style={{color:"black",fontSize:100,position:"relative",margin:"auto",marginLeft:120}} href="https://github.com/celebiali"><AiFillGithub/>
            </a>
            </div>
            <Container>
                <Row>
                    <Col sm={6}><Card style={{marginTop:29}} className="shadow bg-white  rounded scale">
                        <Card.Body style={{fontFamily:'Architects Daughter'}}>
                       <div style={{marginTop:15}}>
                           <h1 style={{fontFamily: 'Architects Daughter',textAlign:"center",marginTop:10,fontSize:35}}>Egghad.io Clone</h1>
                           <p style={{paddingTop:20}}>Egghed.io ana sayfasını HTML ve CSS ile responsive bir şekilde tasarladım. İncele'ye tıklayarak yayınlanmış halini görebilirsiniz.</p>
                       </div>
                            <div style={{display:"flex",marginTop:40}}>
                            <div>
                                <p  style={{background:"#ffd460"}} className="btn">Html</p>
                                <p style={{marginLeft:10,background:"#008CBA",color:"white"}} className="btn">Css</p>
                            </div>
                            <div style={{position: "absolute",right: 45,fontSize:25}}>
                                <Card.Link style={{color:"black"}} href="https://celebiali.github.io/egghead.io/">İncele <FiChevronsRight/></Card.Link>
                            </div>
                        </div>
                        </Card.Body>
                    </Card></Col>
                    <Col sm={6}><Card style={{marginTop:29}} className="shadow bg-white  rounded scale">
                        <Card.Body style={{fontFamily:'Architects Daughter'}}>
                            <div style={{marginTop:15}}>
                                <h1 style={{fontFamily: 'Architects Daughter',textAlign:"center",marginTop:10,fontSize:35}}>Quiz App</h1>
                                <p style={{paddingTop:20}}>Typescript konusunda kendimi geliştirmek için Quiz uygulaması tasarladım. İncele'ye tıklayarak yayınlanmış halini görebilirsiniz.</p>
                            </div>
                            <div style={{display:"flex",marginTop:40}}>
                                <div>
                                    <p style={{background:"#f66c02"}} className="btn">Typescript</p>
                                </div>
                                <div style={{position: "absolute",right: 45,fontSize:25}}>
                                    <Card.Link style={{color:"black"}} href="https://1reactquizapp.netlify.app/">İncele <FiChevronsRight/></Card.Link>
                                </div>
                            </div>
                        </Card.Body>
                    </Card></Col>  <Col sm={6}><Card style={{marginTop:29}} className="shadow bg-white  rounded scale">
                    <Card.Body style={{fontFamily:'Architects Daughter'}}>
                        <div style={{marginTop:15}}>
                            <h1 style={{fontFamily: 'Architects Daughter',textAlign:"center",marginTop:10,fontSize:35}}>My Blog</h1>
                            <p style={{paddingTop:20}}>Alanımla ilgili yazılar paylaşmak için kişisel blog sitesi yaptım. İncele'ye tıklayarak yayınlanmış halini görebilirsiniz.</p>
                        </div>
                        <div style={{display:"flex",marginTop:40}}>
                            <div>
                                <p style={{background:"#f86c6c"}} className="btn">Next.js</p>
                            </div>
                            <div style={{position: "absolute",right: 45,fontSize:25}}>
                                <Card.Link style={{color:"black"}} href="https://alicelebi-blog.vercel.app/">İncele <FiChevronsRight/></Card.Link>
                            </div>
                        </div>
                    </Card.Body>
                </Card></Col>
                </Row>
            </Container>
        </div>
                );
    }
}

export default Projeler;